export class LotNumberRequestModel {
    public constructor(
        public lotNumber: string
    ) {
    }

    public name: string = "";
    public org: string = "";
    public email: string = "";
    public phone: string = "";
    public comment: string = "";

    public vcpId?: number;
}
